import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/focusRingStatic.css';
import './SidebarLayout.css';
export var collapseButton = '_1mr4xg7f-3-5-0 _1mr4xg7e-3-5-0';
export var collapseButtonContainer = '_1mr4xg7c-3-5-0';
export var collapsedSidebar = '_1mr4xg75-3-5-0';
export var collapsedSidebarWrapper = '_1mr4xg71-3-5-0';
export var content = '_1mr4xg73-3-5-0';
export var drawer = '_1mr4xg77-3-5-0';
export var drawerContent = '_1mr4xg79-3-5-0';
export var drawerContentContainer = '_1mr4xg78-3-5-0';
export var drawerHeader = '_1mr4xg7a-3-5-0';
export var expandButton = '_1mr4xg7g-3-5-0 _1mr4xg7e-3-5-0';
export var expandButtonContainer = '_1mr4xg7d-3-5-0';
export var hint = '_1mr4xg76-3-5-0 _z0fq9b4-3-5-0 _z0fq9bd-3-5-0 _z0fq9b6-3-5-0 _z0fq9bc-3-5-0';
export var layoutRoot = '_1mr4xg70-3-5-0';
export var panel = '_1mr4xg72-3-5-0';
export var resizeHandle = '_1mr4xg74-3-5-0';